import React from "react"
import Modal from "react-modal"

import Button from "components/common/Button"
import { Headline3 } from "components/common/styles"
import { modalStyles } from "components/modals/closeComposerModal"

import * as styles from "../styles"

// The folder's one confirm/inform modal: a 360px card with an optional icon, title, description,
// and either a confirm + Cancel pair or — when confirmLabel is omitted — a single OK button for
// purely informational variants.
type ConfirmModalProps = {
  modalName: string
  isOpen: boolean
  title: string
  description: string
  icon?: React.ReactNode
  // Omitted → OK-only variant: no confirm action, OK just closes.
  confirmLabel?: string
  confirmVariant?: "primary" | "danger"
  onConfirm?: () => void
  onClose: () => void
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  modalName,
  isOpen,
  title,
  description,
  icon,
  confirmLabel,
  confirmVariant = "primary",
  onConfirm,
  onClose,
}) => {
  const reactModalStyles = modalStyles(360)
  const isInformational = confirmLabel == null

  return (
    <Modal
      // @ts-ignore
      name={modalName}
      id={modalName}
      ariaHideApp={false}
      isOpen={isOpen}
      // @ts-ignore
      style={reactModalStyles}
      // A pending confirmation must be answered explicitly; informational variants can be
      // dismissed via esc/overlay like any notice.
      onRequestClose={isInformational ? onClose : () => {}}
    >
      <styles.ModalInfoWrapper>
        {icon && <styles.ModalIconWrapper>{icon}</styles.ModalIconWrapper>}
        <styles.ModalContentWrapper>
          <Headline3>{title}</Headline3>
          <styles.ModalInfoPara>{description}</styles.ModalInfoPara>
        </styles.ModalContentWrapper>
        <styles.ModalButtonGroup>
          {isInformational ? (
            // @ts-ignore
            <Button variant="primary" onClick={onClose}>
              OK
            </Button>
          ) : (
            <>
              {/* @ts-ignore */}
              <Button variant={confirmVariant} onClick={onConfirm}>
                {confirmLabel}
              </Button>
              {/* @ts-ignore */}
              <Button variant="secondary" onClick={onClose}>
                Cancel
              </Button>
            </>
          )}
        </styles.ModalButtonGroup>
      </styles.ModalInfoWrapper>
    </Modal>
  )
}

export default ConfirmModal
